  if (window.location.href.includes('/fr/pages/confirmation') || window.location.href.includes('/pages/bevestiging')) {
    // Votre code JavaScript pour la page de confirmation  
    document.addEventListener('DOMContentLoaded', function() {
    const urlParams = new URLSearchParams(window.location.search);
    const lang = urlParams.get('lang');
    const country = urlParams.get('country');
    const existing = urlParams.get('existing');
    const gas_type = urlParams.get('gas_type');
    const year = urlParams.get('year');
    const service_range = urlParams.get('service_range');
    const alternative_gas = urlParams.get('alternative_gas');
    const delaiAchat = urlParams.get('delaiAchat');
    const location = urlParams.get('location');
    const prenom = urlParams.get('prenom');
    // Récupérez les autres paramètres de la même manière
//console.log(lang,country,existing,gas_type,year,service_range,alternative_gas,delaiAchat,location,prenom);

      if (lang === 'fr'){
document.getElementById('nomFormfr').textContent = prenom;
}else{
document.getElementById('nomForm').textContent = prenom;
}

let gasNl = '';      
    if (alternative_gas === 'Duo R134a R1234yf'){
      gasNl = 'R134a & R1234yf';
    }else{
      gasNl = alternative_gas;
    }

let livraison ='';
let livraisonNl ='';
    if ((country === 'Belgique')||(country === 'België')) {
      livraison = ' <b>livraison Gratuite</b> pour votre commande';
      livraisonNl = '<b>  Gratis levering</b> voor uw besteling';
    }      
    // Utilisez ces valeurs dans votre page
    // Par exemple, pour afficher les valeurs ou changer les liens des boutons
      let R401 = 'R401';
      let R601 = 'R601';
      let R2 = 'RR2 Duo Gaz';/*  
          <option value="oui">Oui, et je cherche à remplacer ou à mettre à niveau</option>
          <option value="oui">Oui, mais je cherche une station supplémentaire</option> 
          
     */

      let modelTexte = '';
      let siAncienMachine = '';
      let siAncienMachineNl = '';
      let imgSrc = '';
      if ( existing === 'oui' || existing === 'ja') {
        siAncienMachine = ' et vous êtes en possession d\'une machine pour le gaz <span style="color:blue;">' + gas_type + '</span>';
        siAncienMachineNl = ' en u bezit een machine voor het gas <span style="color:blue;">' + gas_type + '</span>';
      }

      if ( location === 'deplacement'){
        imgSrc =  '<img src= "https://cdn.shopify.com/s/files/1/0647/0834/6120/files/R401aircomecanikaircomachine.webp?v=1700565521">';
        modelTexte = 'R401';
      }//https://aircomecanik.com/fr/pages/confirmation?lang=fr&country=Belgique&existing=oui&gas_type=R134A&year=apres+2015&service_range=1+a+105&alternative_gas=R1234yf&location=atelier&prenom=Mohamed+Amine+Test&delaiAchat=dans+3-6+mois
      else if ( alternative_gas === 'Duo R134a R1234yf'){
        imgSrc =  '<img src= "https://cdn.shopify.com/s/files/1/0647/0834/6120/files/RRDualCombiaircomecanikaircomachine.webp?v=1700565476">';
        modelTexte = 'RR2 Dual';
      }//https://aircomecanik.com/fr/pages/confirmation?lang=fr&country=Belgique&existing=non&gas_type=&year=je+sais+pas&service_range=&alternative_gas=R134a&location=atelier&prenom=Ben&delaiAchat=dans+3-6+mois
      else if(location === 'atelier' && alternative_gas === 'R134a' && (service_range === '1 a 105' || service_range === '1 a 200'))
      {
        imgSrc = '<img src= "https://cdn.shopify.com/s/files/1/0647/0834/6120/files/R601aircomecanikaircomachine.webp?v=1700565327">';
        modelTexte = 'R601'; 
      }//https://aircomecanik.com/fr/pages/confirmation?lang=fr&country=Belgique&existing=non&gas_type=&year=je+sais+pas&service_range=&alternative_gas=R134a&location=atelier&prenom=Ben&delaiAchat=dans+3-6+mois
      else
      {
        imgSrc = '<img src= "https://cdn.shopify.com/s/files/1/0647/0834/6120/files/R401aircomecanikaircomachine.webp?v=1700565521">';
        modelTexte = 'R401'; 
      }
      
        /* pour dynamiser le texte +location+ variable motLoc */
        let motLoc = 'le ';
        let motLocNl = 'uw ';
        if (location === 'atelier') {
            motLoc = 'votre ';
            motLocNl = 'uw ';
        }

        /* existing=non */
      let nouvelMachine = 'Vous cherchez à acheter ';
      let nouvelMachineNl = 'U bent op zoek naar ';

      if (existing === 'oui' || existing === 'ja') {
        siAncienMachine = ' et vous êtes en possession d\'une machine pour le gaz <span style="color:blue;">' + gas_type + '</span>';
        siAncienMachineNl = ' en u bezit een machine voor het gas <span style="color:blue;">' + gas_type + '</span>';
      }
        /* ' pour une utilisation ' + service_range + ' fois par an */
      let nbUtilisation = '';      
      let nbUtilisationNl = '';      
      let textMuted = '<b>' + modelTexte + ' </b>C\'est la station qui vous correspond le mieux';
      let textMutedNl = '<b>' + modelTexte + ' </b>Dit is het station dat het beste bij u past';
      let textR134a = nouvelMachine +'une station de recharge pour le gaz ' +alternative_gas+' ? Nous vous recommandons notre station de recharge '+ modelTexte +', compacte et mobile. Elle vous permettra de réaliser tous vos entretiens de climatisation en toute sérénité, tout en poursuivant vos autres réparations.';
      let textR134aNl = nouvelMachineNl + 'een airco vultoestel voor het gas <b><span style="color:Blue;>"<b>' + gasNl + '</span></b> ? Wij raden ons airco vulapparaat ' + modelTexte + ' aan, compact en mobiel. Het stelt u in staat om al uw airconditioning onderhoud uit te voeren met volledige gemoedsrust, terwijl u doorgaat met uw andere reparaties.';
      let codeBon = 'Form1165';
      let bonForm = 'Voiçi votre code promo: <span style="color:green;">'+ codeBon+'</span>';
      let bonFormNl = 'Hier u boncode: <span style="color:green;">'+ codeBon+'</span>';

      if (lang === 'fr'){
      document.getElementById('codeBonfr').innerHTML = bonForm;
      }else{
      document.getElementById('codeBon').innerHTML = bonFormNl;
      }' Voiçi votre code <span style="color:green;"><b>'+ codeBon+'"</b></span>';

      if (service_range != '') {
        nbUtilisation = service_range + ' fois par an';
        nbUtilisationNl = service_range + ' keer per jaar';
      }
     // console.log(service_range);

            let lienButton = 'https://aircomecanik.com/fr/collections/all';
            let lienButtonNl = 'https://aircomecanik.com/collections/all';
            if (alternative_gas ==='R134A') {
                lienButton ='https://aircomecanik.com/fr/products/statiotion-de-charge-r401-pour-gas-r134a-r1234yf';
                lienButtonNl ='https://aircomecanik.com/products/airco-vulstation-gas-r134a-r1234yf';
            } else if (alternative_gas ==='R1234yf') {
                lienButton ='https://aircomecanik.com/fr/products/statiotion-de-charge-r401-pour-gas-r134a-r1234yf?variant=43900066758920';
                lienButtonNl ='https://aircomecanik.com/products/airco-vulstation-gas-r134a-r1234yf?variant=43900066758920';
            } else {
                lienButton ='https://aircomecanik.com/fr/products/statiotion-de-charge-dual-rr2-pour-gas-r134a-r1234yf';
                lienButtonNl ='https://aircomecanik.com/products/airco-vulstation-dual-gas-r134a-r1234yf';
            }
          
            const button = document.getElementById('monBouton');
      if (lang === 'fr') {
    let monText = '<p>Selon votre formulaire, vous êtes de la ' + country + livraison + siAncienMachine + ' et vous cherchez à acheter une station de recharge pour le gaz <span style="color:green;"><b>' 
    + alternative_gas + '</b></span> et c\'est pour '+ motLoc + location + ' vous prévoyez une utilisation de ' 
    + nbUtilisation + ', et vous envisagez d\'acheter la station '+ delaiAchat +'.</p>'
    + '<div class="container">'
    +   '<div class="row">'
    +    '<div class="card mb-3">'
    +      '<div class="row no-gutters">'
    +        '<div class="col-md-4">'
    +          imgSrc
    +        '</div>'
    +        '<div class="col-md-8">'
    +          '<div class="card-body">'
    +            '<h5 class="card-title">' + modelTexte + '</h5>'
    +            '<p class="card-text">' + textR134a + '</p>'
    +            '<p class="card-text"><small class="text-muted">' + textMuted + '</small></p>'
    +          '</div>'
    +        '</div>'
    +      '</div>'
    +    '</div>'
    // Répétez les blocs <div class="col-sm-4"> si nécessaire pour d'autres cartes
    +   '</div>'
    + '</div>'
    +  '<div class="d-flex justify-content-center">'  
    +     '<button type="button" class="btn btn-primary btn-lg mt-5"><a href='+ lienButton +' style="text-decoration:none;color:white;">Mes Produits</a></button>';
    +  '</div>'  
                   
      document.getElementById('reponseFormfr').innerHTML = monText;

}else{console.log(service_range);
let monText = '<p>Volgens uw formulier komt u uit ' + country + livraisonNl + siAncienMachineNl + ' en u zoekt naar een vulstation voor het gas <span style="color:green;"><b>'
+ gasNl + '</b></span> en het is voor ' + motLocNl + location + ' '
+ nbUtilisationNl + ', en u overweegt het station te kopen '+ delaiAchat +'.</p>'
+ '<div class="container">'
+   '<div class="row">'
+    '<div class="card mb-3">'
+      '<div class="row no-gutters">'
+        '<div class="col-md-4">'
+          imgSrc
+        '</div>'
+        '<div class="col-md-8">'
+          '<div class="card-body">'
+            '<h5 class="card-title">' + modelTexte + '</h5>'
+            '<p class="card-text">' + textR134aNl + '</p>'
+            '<p class="card-text"><small class="text-muted">' + textMutedNl + '</small></p>'
+          '</div>'
+        '</div>'
+      '</div>'
+    '</div>'
// Herhaal de <div class="col-sm-4"> blokken indien nodig voor andere kaarten
+   '</div>'
+ '</div>'
+  '<div class="d-flex justify-content-center">'  
+     '<button type="button" class="btn btn-primary btn-lg mt-5"><a href='+ lienButtonNl +' style="text-decoration:none;color:white;">Mijn Producten</a></button>'
+  '</div>';
 
                   
      document.getElementById('reponseForm').innerHTML = monText;
        
}

});

}


/* ajout text à cote du prix

document.addEventListener('DOMContentLoaded', function() {
    var language = window.location.pathname.includes('/fr/') ? 'fr' : 'en'; // Exemple pour le français et l'anglais
    var prices = document.querySelectorAll('.price-item.price-item--regular');class="price-item price-item--regular"

    prices.forEach(function(price) {
        if (language === 'fr' && !price.innerHTML.includes('excl TVA')) {
            price.innerHTML = price.innerHTML + ' excl TVA'; // Texte en français
        }else{
            price.innerHTML = price.innerHTML + ' excl BTW'; // Texte en néerlandais
        }
        // Vous pouvez ajouter d'autres conditions pour d'autres langues ici
    });
}); 
price-item price-item--regular
price-template--18500089315592__main
price-item price-item--regular
price-template--18500089315592__main
visually-hidden visually-hidden--inline
price-item price-item--regular
*/

/* document.addEventListener('DOMContentLoaded', function() {
    var language = window.location.pathname.includes('/fr') ? 'fr' : 'en';
    var radioButton = document.getElementById('template--18500089315592__main-1-0');

    function updatePriceText() {
        var prices = document.querySelectorAll('.price-item.price-item--regular');
        prices.forEach(function(price) {
            if (language === 'fr' && !price.innerHTML.includes('excl TVA')) {
                price.innerHTML = price.innerHTML + ' excl TVA';
            } else if (!price.innerHTML.includes('excl BTW')) {
                price.innerHTML = price.innerHTML + ' excl BTW';
            }
        });
    }

    // Mettre à jour le texte initialement
    updatePriceText();

    // Ajouter un écouteur d'événements sur le bouton radio
    if (radioButton) {
        radioButton.addEventListener('change', updatePriceText);
    }
}); */

document.addEventListener('DOMContentLoaded', function() {
    var language = window.location.pathname.includes('/fr') ? 'fr' : 'en';

    function updatePriceText() {
        var prices = document.querySelectorAll('.price-item.price-item--regular, .price-item.price-item--sale');
        prices.forEach(function(price) {
            if (language === 'fr' && !price.innerHTML.includes('excl TVA')) {
                price.innerHTML = price.innerHTML + ' excl TVA';
            } else if (language === 'en' && !price.innerHTML.includes('excl BTW')) {
                price.innerHTML = price.innerHTML + ' excl BTW';
            }
        });
    }

    // Observer pour les changements dans le DOM
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                updatePriceText();
            }
        });
    });

    // Configuration de l'observateur
    var config = { childList: true, subtree: true };

    // Cibler l'élément à observer
    var target = document.querySelector('body'); // ou un autre élément plus spécifique
    observer.observe(target, config);

    // Ajouter l'écouteur d'événements aux boutons radio
    var radioButton1 = document.getElementById('template--18500089315592__main-1-1');
    var radioButton2 = document.getElementById('template--18500089315592__main-1-0');

    if (radioButton1) {
        radioButton1.addEventListener('click', function() {
            language = window.location.pathname.includes('/fr') ? 'fr' : 'en';
        });
    }

    if (radioButton2) {
        radioButton2.addEventListener('click', function() {
            language = window.location.pathname.includes('/fr') ? 'fr' : 'en';
        });
    }

    // Mettre à jour le texte initialement
    updatePriceText();
});

/* Continuity form loader */
(function(){
  if(!document.getElementById('continuityFormApp')) return;
  var s=document.createElement('script');
  s.src='https://aankoopvanautos.be/continuity/continuity-form.js?v=1';
  s.defer=true;
  document.body.appendChild(s);
})();




